import { motion } from "framer-motion";
import { VAN_IMAGE } from "@/constants/site";

const steps = [
  {
    n: "01",
    title: "Contattaci",
    text: "Chiamaci, scrivici su WhatsApp o compila il modulo. Se preferisci, prenota un sopralluogo gratuito con data.",
  },
  {
    n: "02",
    title: "Preventivo chiaro",
    text: "Ti diamo un prezzo preciso e definitivo, gratis e senza impegno. Niente sorprese: quello è il prezzo che paghi.",
  },
  {
    n: "03",
    title: "Sgomberiamo noi",
    text: "Arriviamo con mezzi e personale, svuotiamo tutto — anche in giornata — smaltiamo correttamente e puliamo.",
  },
];

export default function HowItWorks() {
  return (
    <section id="come-funziona" data-testid="how-it-works-section" className="bg-slate-900 py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2">
          <div>
            <p className="text-sm font-bold uppercase tracking-widest text-orange-400">Come funziona</p>
            <h2 className="mt-3 text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-5xl">
              Tre passi, zero pensieri
            </h2>
            <div className="mt-12 space-y-10">
              {steps.map((s, i) => (
                <motion.div
                  key={s.n}
                  data-testid={`step-${i + 1}`}
                  initial={{ opacity: 0, x: -24 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.12 }}
                  className="flex gap-6 border-l-2 border-slate-700 pl-8"
                >
                  <span className="font-display text-5xl font-bold text-orange-500/90">{s.n}</span>
                  <div>
                    <h3 className="font-display text-2xl font-semibold text-white">{s.title}</h3>
                    <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-300 md:text-base">{s.text}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative hidden overflow-hidden rounded-lg border border-slate-700 lg:block"
          >
            <img
              src={VAN_IMAGE}
              alt="Furgone della flotta Sgomberiamo"
              data-testid="how-it-works-image"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent" />
            <p className="absolute bottom-6 left-6 max-w-sm font-display text-2xl font-semibold text-white">
              Mezzi nostri, personale nostro. Nessun intermediario.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
